import React, { ChangeEvent, useEffect, useRef, useState } from 'react';
import styles from './TagsForm.module.scss';
import { PlusOutlined } from "@ant-design/icons";
import { Input, InputRef, Tag, Tooltip } from "antd";

type Props = {
    tags: string[];
    setTags: (value: string[]) => void;
};

function TagsForm(props: Props) {

    const { tags, setTags } = props;

    const [inputVisible, setInputVisible] = useState(false);
    const [inputValue, setInputValue] = useState<string>('');
    const [editInputIndex, setEditInputIndex] = useState<number>(-1);
    const [editInputValue, setEditInputValue] = useState<string>('');
    const inputRef = useRef<InputRef>(null);
    const editInputRef = useRef<InputRef>(null);

    useEffect(() => {
        if(inputVisible) 
            inputRef.current?.focus();
    }, [inputVisible]);

    useEffect(() => {
        if(inputValue)
            editInputRef.current?.focus();
    }, [inputValue]);

    const handleClose = (removedTag: string) => {
        const newTags = tags.filter((tag) => tag !== removedTag);
        setTags(newTags);
    };

    const showInput = () => {
        setInputVisible(true);
    };

    const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        setInputValue(e.target.value);
    };

    const handleInputConfirm = () => {
        if (inputValue && tags.indexOf(inputValue) === -1) {
            setTags([...tags, inputValue]);
        }

        setInputVisible(false);
        setInputValue("");
    };

    const handleEditInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        setEditInputValue(e.target.value);
    };

    const handleEditInputConfirm = () => {
        const newTags = [...tags];
        newTags[editInputIndex] = editInputValue;
        setTags(newTags);
        setEditInputIndex(-1);
        setInputValue("");
    };

    return (
        <div className={styles.wrapper}>
            {tags.map((tag, index) => {
                if (editInputIndex === index) {
                    return (
                        <Input
                            ref={editInputRef}
                            key={tag}
                            size="small"
                            className={styles.tagInput}
                            value={editInputValue}
                            onChange={handleEditInputChange}
                            onBlur={handleEditInputConfirm}
                            onPressEnter={handleEditInputConfirm}
                        />
                    );
                }

                const isLongTag = tag.length > 20;
                const tagElem = (
                    <Tag
                        className={styles.editTag}
                        key={tag}
                        closable={index !== -1}
                        onClose={() => handleClose(tag)}
                    >
                        <span
                            onDoubleClick={(e) => {
                                if (index !== 0) {
                                    setEditInputIndex(index);
                                    setEditInputValue(tag);
                                    e.preventDefault();
                                }
                            }}
                        >
                            {isLongTag ? `${tag.slice(0, 20)}...` : tag}
                        </span>
                    </Tag>
                );
                return isLongTag ? (
                    <Tooltip title={tag} key={tag}>
                        {tagElem}
                    </Tooltip>
                ) : (
                    tagElem
                );
            })}
            {inputVisible && (
                <Input
                    ref={inputRef}
                    type="text"
                    size="small"
                    className={styles.tagInput}
                    value={inputValue}
                    onChange={handleInputChange}
                    onBlur={handleInputConfirm}
                    onPressEnter={handleInputConfirm}
                />
            )}
            {!inputVisible && (
                <Tag className={styles.siteTagPlus} onClick={showInput}>
                    <PlusOutlined /> New Tag
                </Tag>
            )}
        </div>
    );
};


export default TagsForm;